import App from '@models/app'
import Users from '@models/users'
import Meals from '@screens/Meals/models/meals'
import Ingredients from '@screens/Ingredients/models/ingredients'
import Scans from '@screens/Scans/models/scans'
import Sensor from '@screens/Settings/models/sensor'
import Address from '@screens/Subscription/models/address'
import Settings from '@screens/Settings/models/settings'
import Activities from '@screens/Activities/models/activities'
import Measurements from '@screens/Measurements/models/measurements'
import Events from '@src/screens/Events/models/events'
import Marketplace from '@src/screens/Marketplace/model/marketplace'
import Education from '@src/screens/Education/model/education'
import Insights from '@src/screens/Insights/models/insights'
import PolicyConsents from '@src/screens/PolicyConsents/models/policyConsents'
import Courses from '@screens/Learn/models/courses'
import Tutorials from '@src/screens/Tutorials/models/tutorials'
import JournalEntries from '@src/screens/JournalEntries/models/journalEntries'
import DailyMeasurements from '@src/screens/DailyMeasurements/models/dailyMeasurements'
import Chatbot from '@src/screens/Chat/models/chatbot'
import Notifications from '@src/models/notifications'
import NutritionistHub from '@src/screens/NutritionistHub/models/nutritionistHub'
import Goals from '@src/models/goals'
import Checklist from '@src/screens/Checklist/models/checklist'
import LabResults from '@src/screens/LabResults/models/labResults'
import InsuranceStatus from '@src/screens/InsuranceStatus/models/insuranceStatus'
import DailyNutrition from '@src/models/dailyNutrition'
import DailyCharts from '@src/models/dailyCharts'
import SupportHub from '@src/screens/Profile/models/supportHub'
import MfaChallenge from '@screens/MfaChallenge/models/mfaChallenge'
import UiFlags from '@src/models/uiFlags'
import AllEvents from '@src/screens/Events/models/allEvents.models'
import ActionGoals from '@src/screens/ActionGoals/models/actionGoals'
import Nora from '@screens/Nora/models/nora'
import UnifiedOnboarding from '@src/models/unifiedOnboarding'
import Plan from '@src/screens/Plan/models/plan.models'

const models = {
  app: new App(),
  users: new Users(),
  scans: new Scans(),
  meals: new Meals(),
  ingredients: new Ingredients(),
  journalEntries: new JournalEntries(),
  sensor: new Sensor(),
  dailyCharts: new DailyCharts(),
  dailyNutrition: new DailyNutrition(),
  events: new Events(),
  allEvents: new AllEvents(),
  address: new Address(),
  settings: new Settings(),
  activities: new Activities(),
  measurements: new Measurements(),
  dailyMeasurements: new DailyMeasurements(),
  marketplace: new Marketplace(),
  education: new Education(),
  insights: new Insights(),
  policyConsents: new PolicyConsents(),
  courses: new Courses(),
  tutorials: new Tutorials(),
  chatbot: new Chatbot(),
  notifications: new Notifications(),
  nutritionistHub: new NutritionistHub(),
  goals: new Goals(),
  checklist: new Checklist(),
  labResults: new LabResults(),
  actionGoals: new ActionGoals(),
  plan: new Plan(),
  insuranceStatus: new InsuranceStatus(),
  supportHub: new SupportHub(),
  mfaChallenge: new MfaChallenge(),
  uiFlags: new UiFlags(),
  nora: new Nora(),
  unifiedOnboarding: new UnifiedOnboarding(),
}

export default models
